// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"361":"d5bbab47","459":"d41c8579","780":"f42fd309","866":"e24c5251","901":"b13065e7"}[chunkId] + ".css";
};